import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    textField: {
        width: 66,
    },
    mainCell: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
    },
    select: {
        width: 100,
    },
    requiredBorderSelect: {
        width: 100,
        border: "1px solid red",
    },
}));
